<script setup lang="ts">
import DestinationInfo from './DestinationInfo.vue';
import LogoContainer from './LogoContainer.vue';
import InformationSection from '@components/util/InformationSection.vue';
import FaqList from '@components/util/faq';
import BusyWay from '@components/util/BusyWay.vue';

const { title, informationPosition = 'top' } = defineProps<{
    title?: string;
    hideBusyWay?: boolean;
    hideTitle?: boolean;
    informationPosition?: 'top' | 'bottom';
}>();
const contentStore = useContentStore();
const {
    landingPageContent,
    landingPageContentLoading,
    landingSections,
    providers,
    providersTitle,
} = storeToRefs(contentStore);
const { isWebApp } = useDevice();
</script>

<template>
    <MrDataTableStyleProvider>
        <DelayHydration>
            <template v-if="!isWebApp">
                <DestinationInfo
                    v-if="
                        landingPageContent &&
                        !landingPageContentLoading &&
                        landingPageContent.cityName !== ''
                    "
                />
                <div v-show="!hideTitle" class="container landing-content">
                    <h2 v-if="title">{{ title }}</h2>
                    <div
                        v-if="landingPageContent?.body"
                        v-html="landingPageContent.body"
                    />
                </div>
                <template v-if="informationPosition === 'top'">
                    <InformationSection
                        v-for="section in landingSections"
                        :key="section.id"
                        :content="section"
                    />
                </template>
                <slot />
                <div v-if="providers.length" class="wrapper">
                    <div class="logo-container">
                        <div class="container">
                            <h2 class="providers-title">
                                {{ providersTitle }}
                            </h2>
                            <LogoContainer :logos="providers" />
                        </div>
                    </div>
                </div>
            </template>
            <div v-if="landingPageContent?.faqs?.length" class="container">
                <h2 v-show="!hideTitle">سوالات متداول</h2>
                <FaqList
                    :items="[
                        { items: landingPageContent?.faqs || [], title: '' },
                    ]"
                />
            </div>
            <template v-if="!isWebApp">
                <template v-if="informationPosition === 'bottom'">
                    <InformationSection
                        v-for="section in landingSections"
                        :key="section.id"
                        :content="section"
                    />
                </template>

                <BusyWay
                    v-show="!hideBusyWay"
                    :page-data="landingPageContent || undefined"
                />
            </template>
        </DelayHydration>
    </MrDataTableStyleProvider>
</template>

<style lang="scss" scoped>
.wrapper {
    background: white;
}

.logo-container {
    padding: 48px 0 106px 0;
}

@media (max-width: $app-mobile-max-width) {
    #second-information .container {
        padding: 48px 16px;
    }

    .providers-title {
        font-style: normal !important;
        @include font-weight(bold, $important: true);
        font-size: 20px !important;
        line-height: 31px !important;
        color: usePalette($p-cool-gray, $p-800) !important;
        margin-bottom: 24px !important;
        text-align: center !important;
    }

    .logo-container {
        padding-bottom: 44px;
    }
}

h2 {
    text-align: center;
}
:deep(.landing-content) {
    padding: 12px 0;
    p,
    li {
        @include tg-m($color: usePalette($p-cool-gray, $p-800));
        text-align: justify;
    }
}
.container {
    width: 100%;
    max-width: 1200px;
    margin-inline: auto;
}
</style>
